export default "__VITE_ASSET__C$31o0rY__"